import * as React from 'react';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  FormControl,
  CircularProgress,
  Grid,
} from '@mui/material';
import api from "../../../services/api";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { pt } from 'yup-locale-pt';
import {
  Autocomplete,
  Checkbox,
  TextField
} from '../../../components';
import { useStoreState, useStoreActions } from 'easy-peasy';
yup.setLocale(pt);


const DialogoLista = ({open, onClose,ano,selectedLista,watchEmpresaId}) => {

  let loading = useStoreState((state) => state.nav.loading);
  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);

  const schema = yup.object({
    nomeForum:yup.string().optional().nullable().required()
      .label('Nome do fórum/conselho'),
    participaAtivamente:yup.boolean().optional().nullable()
      .label('Minha empresa participa ativamente')
  }).required();

  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema)
  });

  const { handleSubmit, reset,
          formState: { isDirty, isSubmitting } } = useFormRef;

  const onSave = async (data) => {
    startLoading();
    try {
      if(data.id){
        await api.http.put(`/07/lista-forum-conselho/empresa/${watchEmpresaId}/${data.id}`,{
          ...data,
          ano
        });
      }else{
        await api.http.post(`/07/lista-forum-conselho/empresa/${watchEmpresaId}`,{
          ...data,
          ano
        });
      }
      stopLoading({ severity: 'success' });
      close(true);
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
      throw error;
    };
  };

  const close = (reload = false) => {
    onClose(reload);
    reset({
      nomeForum:'',
      participaAtivamente:false,
    });
  };


  React.useEffect(() => {
    reset(selectedLista);
  }, [selectedLista]);

  return (
    <Dialog open={open} onClose={() => close()}>
      <DialogTitle>Adicionar fórum/conselho</DialogTitle>
      <DialogContent style={{width:600}}>

        <FormControl  sx={{ my: 1 }} fullWidth>
          <TextField
            field="nomeForum"
            schema={schema}
            useFormRef={useFormRef}
          />
        </FormControl>

        <FormControl sx={{ my: 1 }} fullWidth>
          <Checkbox field="participaAtivamente"
                    schema={schema} useFormRef={useFormRef} />
        </FormControl>

      </DialogContent>
      <DialogActions>
        {loading > 0 &&
         <CircularProgress
           size={30}
           sx={{ 'position': 'absolute', 'left': 25, 'bottom': 12 }} />}
        <Button color="inherit" onClick={() => close()}>
          CANCELAR
        </Button>
        <Button color="primary"
                onClick={handleSubmit(onSave)}
                disabled={!isDirty || isSubmitting}>
          SALVAR
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogoLista;
